import React, {Component} from 'react'
import LoanSubTabUI from "./LoanSubTabUI";
import CacheManager from "../../../cache/CacheManager";
import CacheKeys from "../../../cache/CacheKeys";
import TabUI from "../../../widgets/output/TabUI";

class LoanSubTabSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      accountList: null,
    }
  }

  render() {
    return (
      <LoanSubTabUI
        context={this.props.context}
        tabSelected={this.props.tabSelected}
        onAccountsTabClick={this.onAccountsTabClick}
        onMetaTabClick={this.onMetaTabClick}
        onLeegalityMappingsTabClick={this.onLeegalityMappingsTabClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
  }

  onAccountsTabClick() {
    window.location.href = '/su/score'
  }

  onMetaTabClick() {
    window.location.href = '/su/score/meta'
  }

  onLeegalityMappingsTabClick() {
    window.location.href = '/su/leegality/mappings'
  }
}

export default LoanSubTabSF
